// Signature accent per pundit persona — gives the avatar picker character
// identity (a coloured ring) instead of six gold clones. Used as the `--sig`
// CSS custom property on each avatar. Unknown slugs fall back to the border token.
const SIGNATURE_COLORS: Record<string, string> = {
  borek: "#F2705D", // expressive, hot-blooded — coral red
  hajto: "#E8A13A", // blunt ex-defender — amber
  platynov: "#B388FF", // pretentious tactician — violet
  szpakowski: "#6FB1FC", // poetic, nostalgic — sky blue
  mourinho: "#3FB6A0", // cool, cynical — teal-green
  kulesza: "#C75C86", // boozy PZPN president — wine magenta
};

export const signatureColor = (slug: string): string =>
  SIGNATURE_COLORS[slug] ?? "var(--border)";
